export default "recent-legendary-levels = Recent Legendary Levels\nlink-usage = Forum Usage Guide\nlink-quality-guideline = Quality Guidelines\n"